import { OASOrganizationSchema } from './organization-schema/organization-schema';

export default OASOrganizationSchema;
